import { api } from '@config/api';
import type {
  ModeloConvite,
  PedidoRodada,
  PreviaConvite,
  ResumoConvites,
  Rodada,
} from '../types/Convites';
import type { FiltroLote, Idioma } from '../types/Painel';
import { paramsDosFiltros } from './painelService';

export const convitesService = {
  resumo: (id: string) => api.get<ResumoConvites>(`/campanhas/${id}/convites`).then((r) => r.data),
  previa: (id: string, participanteId?: string, idioma?: Idioma) =>
    api
      .get<PreviaConvite>(`/campanhas/${id}/convites/previa`, {
        params: { participanteId, idioma },
      })
      .then((r) => r.data),
  /** Prévia de um rascunho não salvo (spec 30 R7). */
  previaRascunho: (
    id: string,
    corpo: { idioma: Idioma; modelo?: { assunto: string; corpo: string }; participanteId?: string },
  ) => api.post<PreviaConvite>(`/campanhas/${id}/convites/previa`, corpo).then((r) => r.data),
  iniciar: (id: string, { modo, selecao, idioma }: PedidoRodada) =>
    api
      .post<Rodada>(`/campanhas/${id}/convites/rodadas`, {
        modo,
        idioma,
        selecao:
          selecao && 'filtro' in selecao
            ? { ...selecao, filtro: paramsDosFiltros<Partial<FiltroLote>>(selecao.filtro) }
            : selecao,
      })
      .then((r) => r.data),
  modelos: (id: string) =>
    api
      .get<{ modelos: ModeloConvite[] }>(`/campanhas/${id}/convites/modelos`)
      .then((r) => r.data.modelos),
  salvarModelo: (id: string, idioma: Idioma, m: { assunto: string; corpo: string }) =>
    api.put(`/campanhas/${id}/convites/modelos/${idioma}`, m).then(() => undefined),
  restaurarModelo: (id: string, idioma: Idioma) =>
    api.delete(`/campanhas/${id}/convites/modelos/${idioma}`).then(() => undefined),
};
